import Card from '@/components/ui/Card'
import { Info } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { BenefitKind, ReductionType } from '@/types/cost'
import { REDUCTION_NOTE, getReductionDescription } from '@/types/cost'

interface ReductionInfoProps {
  /** 감경 유형 */
  reductionType: ReductionType
  /** 급여 종류 — 요양원(FACILITY) 20%, 주간보호·방문요양(HOME) 15% 기준으로 비율이 달라진다 */
  benefitKind: BenefitKind
  /** 추가 CSS 클래스 */
  className?: string
}

/**
 * 감경 안내 카드.
 *
 * 선택한 감경 유형과 급여 종류에 따른 본인부담률을 안내합니다.
 * 기준: docs/develop/domain/cost/비용_시뮬레이터_구현_지침.md §7
 * - 본인부담 면제(기초생활수급자): 0%
 * - 60% 감경: 요양원 8% / 재가 6%
 * - 40% 감경: 요양원 12% / 재가 9%
 * 비급여는 어느 경우든 감경되지 않는다는 점을 함께 적는다.
 */
export default function ReductionInfo({
  reductionType,
  benefitKind,
  className,
}: ReductionInfoProps) {
  // 일반(감경 없음)일 경우 안내 카드를 표시하지 않음
  if (reductionType === 'NONE' || reductionType === 'GENERAL') return null

  const description = getReductionDescription(reductionType, benefitKind)

  return (
    <Card
      className={cn(
        'border-cb-primary-light bg-blue-50',
        className
      )}
    >
      <div className="flex gap-3">
        <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-cb-primary-light">
          <Info size={16} className="text-cb-primary" aria-hidden="true" />
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-body-sm font-semibold text-cb-gray-900">
            감경 안내
          </p>
          <p className="text-body-sm text-cb-gray-600">
            {description}
          </p>
          <p className="text-caption text-cb-gray-500">
            {REDUCTION_NOTE}
          </p>
        </div>
      </div>
    </Card>
  )
}
